const currentDomain = window.location.hostname;
export const domainArray = currentDomain.split(".").slice(1).join(".");

export const URL_DOMAINS_XL_LOGO = [
  "dashboard.asexpertise.lecabinetcomptable.com",
  "dashboard.asexpertise.lecabinetcomptable.fr",
];
